import { z } from 'zod';

export const STRONG_PASSWORD_MESSAGE =
  'Senha deve ter pelo menos 8 caracteres, incluindo maiúscula, minúscula, número e caractere especial';

export const STRONG_PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_+\-=\[\]{};':"\\|,.<>/])[A-Za-z\d@$!%*?&#^()_+\-=\[\]{};':"\\|,.<>/]{8,}$/;

export const strongPasswordSchema = z
  .string()
  .min(8, STRONG_PASSWORD_MESSAGE)
  .regex(STRONG_PASSWORD_PATTERN, STRONG_PASSWORD_MESSAGE);
